import { Col, Tooltip, Typography } from 'antd';
import React, { FC } from 'react';
import { Project } from 'api/project';
import { FieldWithValue, Field, FieldValue, FieldValueType } from 'api/tasks';
import { isSpecialProjectField } from 'components/organisms/module-settings/fields/utils';
import {
  Content,
  FieldLabel,
  LabelContainer,
  Help,
} from 'components/organisms/task-pane/task-detail/task-fields/styled';
import { getFieldRenderer as getCustomFieldRenderer } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields';
import { getDefaultProjectFieldRenderer } from '../utils';

interface Props {
  field: Field;
  isReadOnly: boolean;
  values: Array<FieldValue<FieldValueType>>;
  projectData?: Project;
  onCustomFieldChange(fieldValue: any, { fieldId }: FieldWithValue): void;
  onDefaultFieldChange({
    startDate,
    dueDate,
    annualizedRecurringRevenue,
    projectFee,
  });
}

const { Paragraph } = Typography;

export const ProjectOverviewExpandedItem: FC<Props> = ({
  field,
  isReadOnly,
  values,
  projectData,
  onCustomFieldChange,
  onDefaultFieldChange,
}) => {
  const isDefaultField = isSpecialProjectField(field.fieldName);
  const FieldRenderer = isDefaultField
    ? getDefaultProjectFieldRenderer(field)
    : getCustomFieldRenderer(field);

  return (
    <>
      <Col span={8}>
        <LabelContainer>
          <FieldLabel>
            <Paragraph ellipsis={{ rows: 2 }}>
              <Tooltip title={field.fieldLabel}>{field.fieldLabel}</Tooltip>
            </Paragraph>
            {field.description ? (
              <Tooltip title={field.description}>
                <Help />
              </Tooltip>
            ) : null}
          </FieldLabel>
        </LabelContainer>
      </Col>
      <Col span={16}>
        <Content data-cy={`right.content.${field.fieldLabel}`}>
          {FieldRenderer ? (
            isDefaultField ? (
              <FieldRenderer
                isReadOnly={isReadOnly}
                field={field}
                values={values}
                onDefaultFieldChange={onDefaultFieldChange}
                onCustomFieldChange={onCustomFieldChange}
                projectData={projectData}
              />
            ) : (
              <FieldRenderer field={field} onChange={onCustomFieldChange} />
            )
          ) : null}
        </Content>
      </Col>
    </>
  );
};
